import * as React from 'react'
import {RouteComponentProps} from 'react-router'
import {withRouter} from 'react-router'
import {Route} from 'react-router-dom'
import {PlainLink} from './plain-link'

interface IOwnProps {
  to: string
  replace?: boolean
  exact?: boolean
  children: (active: boolean) => any
}
export interface IProps extends IOwnProps, RouteComponentProps<void> {
}

class UnwrappedActivityLink extends React.PureComponent<IProps, {}> {
  public static defaultProps: Partial<IProps> = {
    exact: true,
  }

  public render() {
    return (
      <Route path={this.props.to} exact={this.props.exact} children={({ match }) => (
        <PlainLink to={this.props.to} replace={this.props.replace}>
          {this.props.children(!!match)}
        </PlainLink>
      )}/>
    )
  }
}

// TODO: Typecast workaround for a bug in the type definitions. PR is open but not yet merged.
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/17181
export const ActivityLink = withRouter<IProps>(UnwrappedActivityLink) as React.ComponentClass<IOwnProps>



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/link/activity-link.tsx